import Box, { BoxProps } from '@componentPrimitives/Box';
import Btn, { BtnProps } from '@componentPrimitives/Btn';
import { parseCommonLink } from '@lib/features/commonLinks';
import { isEntry } from '@lib/features/entries';
import { useAppLink, useView } from '@lib/store';
import { maybeGet, mergePropsClassName } from '@liquorice/allsorts-craftcms-nextjs';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import * as styles from './Breadcrumbs.css';

export type BreadcrumbsProps = BoxProps & {
  // includeCurrent?: boolean;
};

const Breadcrumbs = (props: BreadcrumbsProps) => {
  const t = useTranslations('common');
  const view = useView();
  const router = useRouter();

  const home = useAppLink('home');
  const articleIndex = useAppLink('articleIndex');
  const profileIndex = useAppLink('profileIndex');
  const learningIndex = useAppLink('learningIndex');

  const maybeParent = maybeGet(view, 'parent');
  const parent = maybeParent ? parseCommonLink(maybeParent) : home;
  let ancestors = parent ? [parent] : [];

  switch (true) {
    case isEntry(view, 'article'):
      if (articleIndex) ancestors = [articleIndex];
      break;
    case isEntry(view, 'profile'):
      if (profileIndex) ancestors = [profileIndex];
      break;
    case isEntry(view, 'learning'):
      if (learningIndex) ancestors = [learningIndex];
      break;
  }

  const btnProps: Partial<BtnProps> = {
    underline: 'hover',
    variant: 'text',
    startIcon: 'arrowLeft',
    style: { fontWeight: 'normal' },
  };

  const handleBack = () => {
    // Check if we can go back in history
    if (typeof window !== 'undefined' && window.history?.length && window.history.length > 1) {
      // If we can, use router.back()
      router.back();
    } else {
      // Otherwise go home, this is useful for cases where the user navigated to the page directly
      router.push(home?.uri ?? '/');
    }
  };

  if (isEntry(view, 'event'))
    return (
      <Box {...mergePropsClassName(props, styles.root)}>
        <Btn {...btnProps} onClick={handleBack}>
          {t('back')}
        </Btn>
      </Box>
    );

  return (
    <Box {...mergePropsClassName(props, styles.root)}>
      {ancestors?.map((v, i) => (
        <Btn key={i} as="a" href={v.uri ?? ''} {...btnProps}>
          {v.title}
        </Btn>
      ))}
    </Box>
  );
};

export default Breadcrumbs;
